import { Audio } from 'expo-av';
import { useCallback, useEffect, useMemo, useRef } from 'react';

export function useSimpleSound(asset: any, enabled = true) {
  const soundRef = useRef<Audio.Sound>();

  useEffect(() => {
    async function load() {
      try {
        const { sound } = await Audio.Sound.createAsync(asset);
        soundRef.current = sound;
      } catch (error) {
        console.log(error);
      }
    }

    load();

    return function unload() {
      if (!soundRef.current) {
        return;
      }
      soundRef.current.setOnPlaybackStatusUpdate(null);
      soundRef.current.unloadAsync();
    };
  }, []);

  const play = useCallback(() => {
    if (!soundRef.current || !enabled) {
      return;
    }
    soundRef.current.setPositionAsync(0);
    soundRef.current.playAsync();
  }, [enabled]);

  return useMemo(
    () => ({
      play,
    }),
    [play]
  );
}
